module.exports = __webpack_public_path__ + "img/tank-horizontal-unselected.1c81d325.svg";